export default {
  optionValueProp: 'segmentId',
  optionNameProp: 'segmentTypeName',
  searchPlaceholder: 'Wyszukaj: Nazwa typu',
  filterProp: 'segmentTypeName',
}
